import React, { useEffect, useState } from "react";
// @ts-ignore
// import host from '@elliemae/em-ssf-guest';
import { Stack, FormControl, InputLabel, Select, MenuItem, Snackbar, Alert, Typography, Button, Box, IconButton, Menu, Tooltip } from "@mui/material";
import {  Home, Send } from "@mui/icons-material";
import ElliHost from "../services/elliHost";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setPage, setOrderRequestType, setOrderSelectedDeliveryMethods, setConfigId, setLoadingState } from "../state/appSlice";
import { useTypedSelector } from "../hooks/useTypedSelector";
import { PackageTypeUnassigned } from "../utils/constants";
import ConfigTopBar from "../components/shared/config/ConfigTopBar";
import ConfigActionButtons from "../components/shared/config/ConfigActionButtons";
import RefreshMappingCacheButton from "../components/shared/config/RefreshMappingCacheButton";
import OrderButton from "../components/order/OrderButton";
import { REQUEST_TYPES, BUTTON_LABELS } from "../utils/constants";
import { useHasUnsavedChanges } from "../hooks/useHasUnsavedChanges";
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import {
    StyledHeaderContainer,
    StyledAppBar,
    StyledHeaderStack,
    StyledLogoContainer,
    StyledLogo,
    StyledExitButton,
    StyledContentStack,
    StyledHeaderButton,
} from './Header.styles';
import { DtConfirmDialog } from "../components/ui/dialog";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DtAlert from "../components/ui/alert/DtAlert";
import UnsavedChangesDialog from "../components/shared/config/UnsavedChangesDialog";
import { useSaveAndContinue } from "../hooks/useSaveAndContinue";
import { useDiscardAndContinue } from "../hooks/useDiscardAndContinue";
import { useActions } from "../hooks/useActions";
import { CONFIG_ID_SELECTOR_CONTROL_ID } from "../models/configuration/plugin/IConfiguration";
import { GetControlOptions } from "../utils/controlOptionsHelper";
import { ActionType } from "../state/actions";

const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const packages = useTypedSelector((state) => state.configPlugInData.data?.Configuration.Packages);
    const currentPage = useTypedSelector((state) => state.appSlice.page);
    const appState = useTypedSelector((state) => state.appSlice);
    const configMisc = useTypedSelector((state) => state.configPlugInData.data?.Configuration?.DefaultValues);
    const sendValidationState = useTypedSelector((state) => state.configPlugInData.data?.Configuration.SendValidations ?? null);
    const isASO = useTypedSelector((state) => state.appSlice.isASO);
    const globalConfigIds = useTypedSelector((state) => state.appSlice.configIds);
    const globalConfigId = useTypedSelector((state) => state.appSlice.configId);
    const otherControls = useTypedSelector((state) => state.configPlugInData.data?.Configuration?.OtherControls);
    const { getConfigPlugInData } = useActions();

    const configIdControl = otherControls?.find(c => c.Id === CONFIG_ID_SELECTOR_CONTROL_ID);
    const configIdOptions = GetControlOptions(configIdControl, '', appState);
    const configurationIds = useTypedSelector((state) => state.configPlugInData.data?.Configuration?.ConfigurationIds);
    const enabledConfigEntries = (configurationIds ?? []).filter(e => e.Enabled);
    const activeConfigEntry = configurationIds?.find(e => e.Id === globalConfigId);
    // Alert state
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('info');

    // TODO: Fix TypeScript issue with orderState
    const orderState = useTypedSelector((state) => (state.appSlice as any).orderState) || {
        packageId: '',
        altPackageId: '',
        parentPackageId: '',
        requestType: '',
        selectedDeliveryMethods: [],
        selectedDocumentList: [],
        requestTypeVisible: false,
        requestTypeEnable: false,
        requestTypeTitle: ''
    };

    const configurationPages = [
        'Servers',
        'Packages',
        'Delivery Methods',
        'Other Controls',
        'Send Validations',
        'Response Messages',
        'Doc Bundling', //Pushback 
        'Configuration', //Pushback 
        'Xpath Mappings', //Pushback 
        'Dashboard', //Pushback 
        'Configuration', //Misc 
        'Evaluation Result',
        'Bundling',
        'Misc',
        'Pushback'
    ];

    const isConfigurationPage = configurationPages.includes(currentPage || '');
    const isOrderPage = location.pathname === '/Order' || location.pathname.startsWith('/Order');
    const hasUnsavedChanges = useHasUnsavedChanges();

    const handleRequestTypeChange = (event: any) => {
        const newRequestType = event.target.value;
        dispatch(setOrderRequestType(newRequestType));
        dispatch(setOrderSelectedDeliveryMethods([]));
    };

    const openAlert = (message: string, severity: 'success' | 'error' | 'info' | 'warning' = 'info') => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const [exitConfirmOpen, setExitConfirmOpen] = useState(false);
    const [unsavedDialogOpen, setUnsavedDialogOpen] = useState(false);

    const closeEpcForm = async () => {
        setExitConfirmOpen(true);
    };

    const handleExitConfirm = async () => {
        setExitConfirmOpen(false);
        await ElliHost.getInstance().closeApplication();
    };

    const handleExitCancel = () => {
        setExitConfirmOpen(false);
    };

    const navigateToHome = () => {
        // Get the first sidebar link name, using the same logic as SideBar
        let sideGroupsList: Array<{ 'name': string, 'path': string }> = [];
        const packageSort = packages?.map(pkg => ({ ...pkg })).sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0)) ?? [];

        if (packageSort) {
            for (let i = 0; i < packageSort.length; i++) {
                if (!sideGroupsList.some(g => g.name === packageSort[i].Group) && packageSort[i].Group?.toLowerCase() !== PackageTypeUnassigned.toLowerCase())
                    sideGroupsList.push({ 'name': packageSort[i].Group, 'path': './Order' });
            }

            if (sideGroupsList.length > 0) {
                const firstGroupName = sideGroupsList[0]?.name;
                document.getElementsByClassName("sideNavNavPage")[0].scrollTo(0, 0);
                dispatch(setPage(firstGroupName ?? ""));
                navigate("/Order");

                window.dispatchEvent(new CustomEvent('navigateToHome'));
            }
        }
    }

    const requestNavigateToHome = () => {
        if (isConfigurationPage && hasUnsavedChanges) {
            setUnsavedDialogOpen(true);
            return;
        }
        navigateToHome();
    };

    const { handleSaveAndContinue, savingAndContinue } = useSaveAndContinue({
        navigateToHome,
        setUnsavedDialogOpen,
        onError: (message) => openAlert(message, "error")
    });

    const handleDiscardAndContinue = useDiscardAndContinue({
        navigateToHome,
        setUnsavedDialogOpen
    });

    useEffect(() => {
        // Calculate sidebar width based on CSS grid definition (2/12 columns)
        const setSidebarWidth = () => {
            const viewportWidth = window.innerWidth;
            // Calculate sidebar width as 2/12 of viewport width (matching CSS grid span 2)
            // Use fractional calculation for more precision and better responsiveness
            const sidebarWidth = (viewportWidth * 2) / 12;
            document.documentElement.style.setProperty('--sidebar-width', `${sidebarWidth}px`);
        };

        setSidebarWidth();

        window.addEventListener('resize', setSidebarWidth);

        // Clean up
        return () => {
            window.removeEventListener('resize', setSidebarWidth);
        };
    }, []);

    // Reset requestType when navigating to other pages
    useEffect(() => {
        if (!isOrderPage && orderState.requestType) {
            const defaultRequestType = configMisc?.DefaultRequestType || REQUEST_TYPES.LIGHTS_OUT;
            dispatch(setOrderRequestType(defaultRequestType));
        }
    }, [isOrderPage, orderState.requestType, configMisc?.DefaultRequestType, dispatch]);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleDropdownClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleDropdownClose = () => {
        setAnchorEl(null);
    };

    const handleRequestTypeSelect = (value: string) => {
        handleDropdownClose();
        handleRequestTypeChange({ target: { value } });
    };

    // ASO: configurationIds burger menu state
    const [displayConfigIds, setDisplayConfigIds] = useState<string[]>([]);
    const [selectedConfigId, setSelectedConfigId] = useState<string>("");
    const [configMenuAnchorEl, setConfigMenuAnchorEl] = useState<null | HTMLElement>(null);

    useEffect(() => {
        if (!isASO) return;
        const ids = Array.isArray(globalConfigIds) ? globalConfigIds : [];
        setDisplayConfigIds(ids);

        const initialId = globalConfigId && ids.includes(globalConfigId) ? globalConfigId : (ids[0] || "");
        setSelectedConfigId(initialId);
        if (initialId && initialId !== globalConfigId) {
            dispatch(setConfigId(initialId));
        }
    }, [isASO, globalConfigIds, globalConfigId, dispatch]);

    const openConfigMenu = (event: React.MouseEvent<HTMLElement>) => {
        setConfigMenuAnchorEl(event.currentTarget);
    };

    const closeConfigMenu = () => {
        setConfigMenuAnchorEl(null);
    };

    const selectConfigId = (newId: string) => {
        setSelectedConfigId(newId);
        dispatch(setConfigId(newId));
        closeConfigMenu();
    };

    // Non-ASO config ID selector state and handler
    const [configIdMenuAnchorEl, setConfigIdMenuAnchorEl] = useState<null | HTMLElement>(null);

    const handleConfigIdSelect = async (entryId: string) => {
        setConfigIdMenuAnchorEl(null);
        const prevConfigId = globalConfigId;
        dispatch(setLoadingState({ loading: true }));
        dispatch(setConfigId(entryId));
        // Invalidate the cached config slices before loading, otherwise the reset
        // discards the configuration that was just fetched for the new id.
        dispatch({ type: ActionType.CONFIG_ID_CHANGED });
        try {
            const succeeded = await (getConfigPlugInData(entryId, appState.accessToken, true) as unknown as Promise<boolean>);
            if (succeeded === false) {
                dispatch(setConfigId(prevConfigId!));
            } else {
                localStorage.setItem("configurationId", entryId);
            }
        } finally {
            dispatch(setLoadingState({ loading: false }));
        }
    };

    return (
        <StyledHeaderContainer sx={{ height: 60, minHeight: 60, maxHeight: 60 }}>
            <Snackbar
                open={alertOpen}
                autoHideDuration={4000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <StyledAppBar sx={{ height: 60, minHeight: 60, maxHeight: 60 }}>
                <StyledHeaderStack direction="row" alignItems="center" justifyContent="space-between" spacing={0}>
                    <StyledLogoContainer>
                        <StyledLogo
                            className="logo"
                        onClick={requestNavigateToHome}
                        />
                    </StyledLogoContainer>
                    {!isASO && <StyledContentStack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        spacing={1}
                    >

                        <Stack direction="row" alignItems="center" spacing={1}>
                            {isConfigurationPage && (
                                <>
                                    <RefreshMappingCacheButton />
                                    <ConfigTopBar error={null} />
                                    <ConfigActionButtons onError={(message) => openAlert(message, "error")} />
                                </>
                            )}

                            {isOrderPage && (
                                <Stack direction="row" justifyContent="end" spacing={2}>
                                    {configIdOptions?.IsVisible && configIdOptions?.IsEnabled && enabledConfigEntries.length > 0 && (
                                        <>
                                            <StyledHeaderButton
                                                size="small"
                                                onClick={(e) => setConfigIdMenuAnchorEl(e.currentTarget)}
                                            >
                                                <Typography sx={{ ml: 1, fontWeight: 500, letterSpacing: 0.8 }}>
                                                    {activeConfigEntry?.Alias || activeConfigEntry?.Id || 'Select Config'}
                                                </Typography>
                                                <ArrowDropDownIcon />
                                            </StyledHeaderButton>
                                            <Menu
                                                anchorEl={configIdMenuAnchorEl}
                                                open={Boolean(configIdMenuAnchorEl)}
                                                onClose={() => setConfigIdMenuAnchorEl(null)}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            >
                                                {enabledConfigEntries.map((entry, idx) => (
                                                    <MenuItem
                                                        key={`config-id-${idx}`}
                                                        onClick={() => handleConfigIdSelect(entry.Id!)}
                                                    >
                                                        {entry.Alias || entry.Id}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </>
                                    )}
                                    {configMisc?.RequestTypeAvailability === REQUEST_TYPES.BOTH && orderState.requestTypeVisible && (
                                        <>
                                            <StyledHeaderButton
                                                size="small"
                                                onClick={handleDropdownClick}
                                                sx={{ color: "inherit" }}
                                                disabled={!orderState.requestTypeEnable}
                                            >
                                                <Typography sx={{ ml: 1, fontWeight: 500, letterSpacing: 0.8 }}>
                                                    {orderState.requestType || configMisc?.DefaultRequestType}
                                                </Typography>
                                                <ArrowDropDownIcon />
                                            </StyledHeaderButton>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={handleDropdownClose}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            >
                                                {[REQUEST_TYPES.LIGHTS_OUT, REQUEST_TYPES.LIGHTS_ON]?.map((rt, i) => (
                                                    <MenuItem
                                                        value={rt}
                                                        key={`requestType-${i}`}
                                                        onClick={() => handleRequestTypeSelect(rt)}
                                                        selected={rt === (orderState.requestType || configMisc?.DefaultRequestType)}
                                                    >
                                                        {rt}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </>
                                    )}
                                    <OrderButton
                                        altPackageId={orderState.altPackageId}
                                        parentTypeId={orderState.parentPackageId}
                                        requestType={orderState.requestType}
                                        packageId={orderState.packageId}
                                        deliveryMethods={orderState.selectedDeliveryMethods}
                                        disabled={orderState.packageId === ''}
                                        alertHandler={openAlert}
                                        selectedDocuments={orderState.selectedDocumentList}
                                        token={appState.accessToken ?? ""}
                                        alwaysPreviewDocuments={configMisc?.PreviewAttachmentsAlways ?? false}
                                        buttonText={orderState.requestType === REQUEST_TYPES.LIGHTS_OUT && orderState.selectedDeliveryMethods.length < 1 ? BUTTON_LABELS.PREVIEW : BUTTON_LABELS.SEND}
                                        sendValidations={sendValidationState}
                                        startIcon={<Send fontSize="small" />}
                                    />

                                </Stack>
                            )}
                        </Stack>
                    </StyledContentStack>}
                    

                    <Stack direction='row' alignItems='center' gap={2} marginRight={2}>
                        {isASO ? (
                            <>
                                <Stack direction="row" justifyContent="end" spacing={2}>
                                    <StyledHeaderButton
                                        size="small"
                                        onClick={openConfigMenu}
                                        sx={{ color: "inherit" }}
                                        disabled={Boolean(appState.defaultPackageId)}
                                    >
                                        <Typography sx={{ ml: 1, fontWeight: 500, letterSpacing: 0.8 }}>
                                            {globalConfigId || "Select ConfigurationId"}
                                        </Typography>
                                        <ArrowDropDownIcon />
                                    </StyledHeaderButton>
                                    <Menu
                                        anchorEl={configMenuAnchorEl}
                                        open={Boolean(configMenuAnchorEl)}
                                        onClose={closeConfigMenu}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    >
                                        {displayConfigIds.map((id, idx) => (
                                            <MenuItem
                                                key={`aso-config-${idx}`}
                                                selected={id === selectedConfigId}
                                                onClick={() => selectConfigId(id)}
                                            >
                                                {id}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Stack>
                            </>
                        ) : (
                            <>
                                <Tooltip title="Exit Docutech EPC">
                                    <StyledExitButton
                                        onClick={closeEpcForm}
                                        size="small"
                                        sx={{ color: 'background.paper' }}
                                    >
                                        <ExitToAppRoundedIcon />
                                    </StyledExitButton>
                                </Tooltip>
                            </>
                        )}
                    </Stack>
                </StyledHeaderStack>
            </StyledAppBar>
            {/* Confirm Exit Modal */}
            <UnsavedChangesDialog
                open={unsavedDialogOpen}
                onSaveAndContinue={handleSaveAndContinue}
                onDiscard={handleDiscardAndContinue}
                onCancel={() => setUnsavedDialogOpen(false)}
                loading={savingAndContinue}
            />
            <DtConfirmDialog
                maxWidth="xs"
                open={exitConfirmOpen}
                onClose={handleExitCancel}
                onConfirm={handleExitConfirm}
                title="Exit Docutech EPC"
                message="Are you sure you want to exit the Docutech EPC application?"
                subMessage={
                    appState.isAdmin && isConfigurationPage
                    && <DtAlert severity="warning">Unsaved changes will be lost. Please save your changes before exiting.</DtAlert>
                }
                confirmLabel="Yes, Exit"
                cancelLabel="Cancel"
                confirmColor="primary"
            />
        </StyledHeaderContainer>
    );
};

export default Header;